/* global angular */

/**
 * @doc module
 * @id GcPopup
 * @description GcPopup
 */
angular.module('gc.auth-popin', ['gc.services'])
.constant('gc.popup.version', '1.2')
/**
 * @doc directive
 * @id GraphComment:popup
 *
 * @description
 */
.controller('AuthPopinController', [
'$scope',
'$element',
'$rootScope',
'$window',
'$document',
'$log',
'$timeout',
'BASE_URL',
'API_URL',
'BO_URL',
'Utils',
'GcUser',
'LanguageUtils',
'PostMessageService',
'CommentService',
'GraphLogin',
function ($scope, $element, $rootScope, $window, $document, $log, $timeout,
          BASE_URL, API_URL, BO_URL, Utils, GcUser, LanguageUtils, PostMessageService, CommentService, GraphLogin) {
  'use strict';
  var interval;
  var win;
  var POPUP_HEIGHT = 650; // approximate size of the signup popup with custom image

  $scope.BASE_URL = BASE_URL;
  $scope.user = {};
  $scope.data = {};
  $scope.page;
  $scope.recoverUrl = BO_URL + '/#forgot/';

  $scope.data.language = LanguageUtils.getBrowserLanguage();

  $scope.showPage = {
    back: function(event) {
      event && event.preventDefault();
      if ($scope.prevPage) {
        $scope.showPage[$scope.prevPage]();
      } else {
        $scope.showPage.signin();
      }
    },
    signin: function(event) {
      event && event.preventDefault();
      $scope.prevPage = $scope.page;
      $scope.page = 'signin';
      $scope.showLink = 'signup';
      hideSplash();
      mixpanel.track('auth:signin_show');
    },
    signup: function(event) {
      event && event.preventDefault();
      $scope.prevPage = $scope.page;
      $scope.page = 'signup';
      $scope.showLink = 'signin';
      showSplash();
      $scope.conflicted_username = null;
      $scope.conflicted_email = null;
      mixpanel.track('auth:signup_show');
    },
    signupEmail: function(event) {
      event && event.preventDefault();
      $scope.prevPage = $scope.page;
      $scope.page = 'signupEmail';
      $scope.showLink = 'signin';
      showSplash();
      $scope.conflicted_username = null;
      $scope.conflicted_email = null;
      mixpanel.track('auth:signup_email_show');
    },
    guest: function(event) {
      event && event.preventDefault();
      $scope.prevPage = $scope.page;
      $scope.page = 'guest';
      $scope.showLink = 'signin';
      showSplash();
      mixpanel.track('auth:guest_show');

      // $timeout(function () {
      //   if (Utils.isProd()) {
      //     window.grecaptcha.render(document.querySelector('.gc-guest-form .gc-btn-primary'), {
      //       badge: 'bottomleft',
      //     });
      //   }
      // });
    },
    resetPass: function(event) {
      event && event.preventDefault();
      $scope.prevPage = $scope.page;
      $scope.page = 'resetPass';
      $scope.showLink = 'signup';
      hideSplash();
      mixpanel.track('auth:reset_pass_show');
    },
  }

  function closePopin() {
    $scope.show = false;
  }

  function showSplash() {
    if ($scope.splashStart) return;
    $scope.splashStart = false;
    $timeout(function () {
      $scope.splashStart = true;
    }, 500);
  }

  function hideSplash() {
    $scope.splashStart = false;
  }

  $scope.popinStyle = {};
  $scope.defaultGcHeight = document.body.offsetHeight;
  
  $rootScope.$on('show:popup', function (event, params) {
    if(GraphLogin.get())
      GraphLogin.get().onModalResize((size) => {
        var height = $scope.defaultGcHeight;
        if(size > 0) {
          $scope.defaultGcHeight =  document.body.offsetHeight;
          height = Math.max($scope.defaultGcHeight, size);
        } 
        
        PostMessageService.postMessage('gc-height', {
          height: Math.ceil(height)
        });

      })

    $scope.website = CommentService.website;
 
    if(!$scope.website.sso.active)
      switch (params.page) {
        case 'signin':
          GraphLogin.get().login()
          $rootScope.$emit('scrollTo', 0);
          return;
        case 'signup':
          GraphLogin.get().signup()
          return;
        default:
          break;
      }
    else 
      switch (params.page) {
        case 'signin':
          PostMessageService.postCommand('login');
          return;
        case 'signup':
          PostMessageService.postCommand('signup');
          return;
        default:
          break;
      }

    if ($scope.website.sso.active && $scope.website.sso.login_redirect) {

      var ssoUrl = $scope.website.sso.link;

      if (Utils.inApp()) {
        ssoUrl = Utils.appendGetParam(ssoUrl, 'gc_url=' + encodeURIComponent(window.location.href));
        window.location.href = ssoUrl;
      }

      else {
        ssoUrl = Utils.appendGetParam(ssoUrl, 'gc_url=' + encodeURIComponent(Utils.getParameterByName('url') || window.location.href));
        PostMessageService.postMessage('gc-redirect', { url: ssoUrl });
      }

      return
    }

    // do sso auth
    if ($rootScope.ssoUnidirectionalEnabled()) {
      PostMessageService.postMessage('gc-sso-auth');
      return;
    }

    $scope.show = true;

    if (!$scope.showPage[params.page]) {
      throw 'GcPopup: page "' + params.page + '" not found';
    }

    // force 'signin' if SSO enabled
    if ($scope.ssoEnabled() && params.page !== 'signin') {
      params.page = 'signin';
    }

    $scope.showPage[params.page]();

    if (params.data) {
      $scope.data = params.data;
    }

    // Init the custom image
    //$log.debug('scope.customImage : ', $scope.customImage);
    $scope.customImage = CommentService.getCustomImage();
    $scope.websiteId = $scope.website ? $scope.website._id : null;

    $scope.logins = $scope.website.login.order.slice().filter(function(login) {
      return !!$scope.website.login[login];
    });

    $scope.hasSocialLogins = $scope.logins[0] !== 'email';

    showSplash();

    if (params.target) {
      var rect = params.target.getBoundingClientRect();
      var top = rect.top;
      top += params.offset || 0;
      top = Math.max(0, top);
    } else {
      var top = 0;
    }

    $scope.popinStyle = {
      top: (Utils.inIframe() ? top : 0) + 40 + 'px',
    };
  });

  $scope.ssoEnabled = function() {
    return (
      $scope.website.sso &&
      $scope.website.sso.unidirectional === false &&
      $scope.website.sso.active
    );
  };

  $scope.signin = function () {
    $scope.err = null;

    var ssoUrl = $scope.ssoEnabled() && $scope.website.sso.link;

    if ($scope.website.sso.active && $scope.website.sso.login_redirect) {
      ssoUrl = Utils.appendGetParam(ssoUrl, 'gc_url=' + window.location.href);
      window.location.href = ssoUrl;
      return
    }

    GcUser
      .login($scope.user.username, $scope.user.password, ssoUrl)
      .then(function () {
        closePopin();
        $log.log('Logged in', GcUser.getUser().username);
        mixpanel.track('auth:signin_success');
      }, function (resp) {
        if (resp.status === 401) {
          $scope.err = 'bad credentials';
        } else {
          $scope.err = 'server error';
        }
      });
  };

  $scope.signup = function () {
    $scope.signupErr = null;
    $scope.signupConflictedUsername = null;
    $scope.signupConflictedEmail = null;

    GcUser
    .register($scope.data.username, $scope.data.password, $scope.data.email, $scope.data.avatar)
    .then(function (resp) {
      mixpanel.track('auth:signup_email_success');
      mixpanel.alias(resp.data._id); // todo check

      GcUser
        .login($scope.data.username, $scope.data.password)
        .then(function () {
          closePopin();
          $log.log('Logged in', GcUser.getUser().username);
        }, function () {
          $scope.err = 'server error';
        });
    }, function (resp) {
      var content = resp.data;

      if (content && content.err) {
        if (content.err.indexOf('username already used') !== -1) {
          $scope.signupConflictedUsername = $scope.data.username;
        } else if (content.err.indexOf('email already used') !== -1) {
          $scope.signupConflictedEmail = $scope.data.email;
        } else {
          $scope.signupErr = 'unknown error';
        }
      }
    });
  };

  // for 'guest' form
  $scope.forms = {};
  $scope.submitGuest = function () {
    // google recaptch is hijacking button's disabled attribute
    // so we add validation here
    if ($scope.forms.fGuest.$invalid) return;

    GcUser.setGuest({
      username: $scope.data.username,
      email: $scope.data.email,
    });
    closePopin();
    mixpanel.track('auth:guest_success');
    $scope.$apply();
  };
  window.onGuestFormSubmit = $scope.submitGuest.bind($scope);

  $scope.resetPass = function() {
    $scope.resetPassUserNotFound = null;
    GcUser
      .resetPass($scope.user.email)
      .then(function () {
        $scope.showResetPassSuccess = true;
        mixpanel.track('auth:reset_pass_success');
      }, function (resp) {
        if (resp.data && resp.data.err && resp.data.err === 'user_not_found') {
          $scope.resetPassUserNotFound = resp.data.msg;
        }
      });
  };

  /**
   * Internal logic
   */
  function loginAndWatch(provider) {
    // If the user was voting
    var a = $rootScope.$on('logged_in', function () {
      win.close();
      $scope.show = false;
      // unbind
      a();
    });

    $scope.websiteId = $scope.website ? $scope.website._id : null;

    var popupUrl = $scope.ssoEnabled()
      ? $scope.website.sso[provider] + '?origin_url=' + Utils.getParameterByName('url')
      : API_URL + '/users/' + provider + '?from_website=' + $scope.websiteId;

    $log.debug('popupUrl', popupUrl);

    if (Utils.inApp() || Utils.isFacebookApp()) {
      popupUrl += '&redirect=true';

      if (Utils.getParameterByName(provider + '_redirect_after_login')) {
        popupUrl += '&redirect_after_login=' + encodeURIComponent(Utils.getParameterByName(provider + '_redirect_after_login'));
      } else {
        if (Utils.inIframe()) {
          var url = Utils.removeHash(Utils.getParameterByName('url'));
          popupUrl += '&redirect_after_login=' + encodeURIComponent(url);
        } else {
          popupUrl += '&redirect_after_login=' + encodeURIComponent(window.location.href);
        }
      }

      if (Utils.inIframe()) {
        window.top.location.href = popupUrl;
      } else {
        window.location.href = popupUrl;
      }
    }

    else {
      win = window.open(popupUrl, 'GraphComment Social Login', 'width=700,height=700');
    }

    // The callback of the popup
    $window.socialPopupClose = function (jwt_token) {
      $log.debug('socialPopupClose()');
      win && win.close();
      GcUser.refresh(jwt_token, function (err, user) {
        if (!err) {
          // TODO Handle error
          $log.debug('Social Login [ New user: ', user, ' ]');
          mixpanel.track('auth:social_' + provider + '_success');
        }
      });
    };
  }

  $scope.loginWith = function (provider) {
    $log.debug('loginAndWatch(' + provider + ')');
    mixpanel.track('auth:social_' + provider + '_show');
    loginAndWatch(provider);
  };

  $scope.overlayClick = function(event) {
    if (event.target.classList.contains('gc-popin-wrapper')) {
      $scope.cancelAndClose();
    }
  };

  $scope.openRegisterPopup = function() {
    // If the user was voting
    var a = $rootScope.$on('logged_in', function () {
      win.close();
      $scope.show = false;
      // unbind
      a();
    });

    var popupUrl = $scope.website.sso.register;
    popupUrl = Utils.appendGetParam(popupUrl, 'gc_url=' + window.location.href);

    win = window.open(popupUrl, 'Register', 'width=700,height=700');

    // The callback of the popup
    $window.socialPopupClose = function (jwt_token) {
      $log.debug('socialPopupClose()', jwt_token);
      win.close();
      GcUser.refresh(jwt_token, function (err, user) {
        if (!err) {
          // TODO Handle error
          $log.debug('Social Login [ New user: ', user, ' ]');
          mixpanel.track('auth:social_' + provider + '_success');
        }
      });
    };
  }

  // preview avatar
  $scope.onAvatarUpload = function(event) {
    var files = event.target.files;
    if (files && files.length) {
      var reader = new FileReader();
      reader.onload = function(e) {
        $scope.avatarSrc = e.target.result;
        $scope.$apply();
      };
      reader.readAsDataURL(files[0]);
    }
  };

  $scope.cancelAndClose = function () {
    mixpanel.track('auth:cancel');
    $rootScope.$broadcast('auth:cancel');
    closePopin();

    if (interval) {
      clearInterval(interval);
    }

    if (win) {
      win.close();
    }
  };

}])
.directive('authPopin', [
  '$document', '$timeout', '$sce', '$translate', '$rootScope',
  function ($document, $timeout, $sce, $translate, $rootScope) {
  'use strict';

  return {
    restrict: 'E',
    replace: true,
    scope: true,
    templateUrl: 'authPopin.html',
    controller: 'AuthPopinController',
    controllerAs: 'popup',
    bindToController: true,
    link: function (scope, el) {

      $document.on('keyup.gc-auth', function(event) {
        if (event.keyCode === 27) { // ESC
          scope.show = false;
        }
      });

      scope.$on('$destroy', function() {
        $document.off('keyup.gc-auth');
      });
    },
  };
}]);
